import * as React from 'react';

import { getDepartment, updateDepartment } from '../../../action/admin/Department';
import Department from '../../../component/Department';
import Loader from '../../../component/common/Loader';
import { validateForm } from '../../../utils';
import CONSTANT from '../../../constant';

class EditDepartment extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            code: { value: props.match.params.code },
            departmentList: undefined,
            showLoader: false
        }
    }

    componentDidMount() {
        this.loadList()

    }

    public render() {
        const { departmentList, showLoader } = this.state;
        return (
            <React.Fragment>

                <section>
                    <div className="col-lg-12 main-container">
                        <div className="fluid-container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="col-lg-12 mt-4">
                                        <div className="row">
                                            <div className="col-lg-6 pl-0">
                                                <h5 className="heading-h1">Edit Department Skills</h5>
                                            </div>
                                        </div>
                                    </div>

                                    {
                                        departmentList &&
                                        <Department
                                            onSubmit={this.onSubmit}
                                            department={departmentList}
                                        />
                                    }


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    showLoader && <Loader />
                }
            </React.Fragment>

        )
    }

    loadList = () => {
        this.setState({ showLoader: true })
        getDepartment(this.state.code.value)
            .then((res: any) => {
                if (res) {
                    if (res.result) {
                        alert('Record Update Successfully')
                        this.setState({
                            departmentList: res.result,
                            showLoader: false
                        });
                    }
                }
            })
    }

    onSubmit = (model: any) => {
        //  model.leaveTypeId = this.state.leaveTypeId.value
        this.setState({ showLoader: true });
        updateDepartment(model)
            .then((res: any) => {
                console.log(res);
                this.setState({ showLoader: false });
                this.props.history.push(CONSTANT.url.departmentList)
            })
            .catch((err: any) => {
                alert(err)
            })
    }
}

export default EditDepartment;